import { ClientState } from '@features/client-state/client-state';
import { createAction, props } from '@ngrx/store';
import { AppActions } from '../app-actions.enum';

export const loadStateSuccess = createAction(
  AppActions.LOAD_STATE_SUCCESS,
  props<{ clientStateRequestDTO: ClientState }>(),
);
